(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_157ed30"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('[class*="qt-row-"]').forEach(function(row){
    if(row.dataset.qtWired) return;
    row.dataset.qtWired = 'true';
    var rail = row.closest('[class*="__rail"]');
    if(!rail) return;
    var prev = rail.querySelector('.qt-arrow-prev');
    var next = rail.querySelector('.qt-arrow-next');

    function updateArrows(){
      if(!prev || !next) return;
      var atStart = row.scrollLeft <= 2;
      var atEnd = row.scrollLeft + row.clientWidth >= row.scrollWidth - 2;
      prev.setAttribute('data-hidden', atStart ? 'true' : 'false');
      next.setAttribute('data-hidden', atEnd ? 'true' : 'false');
    }

    if(next) next.addEventListener('click', function(){
      row.scrollBy({left: row.clientWidth * 0.9, behavior: 'smooth'});
    });
    if(prev) prev.addEventListener('click', function(){
      row.scrollBy({left: -row.clientWidth * 0.9, behavior: 'smooth'});
    });

    row.addEventListener('scroll', updateArrows);
    window.addEventListener('resize', updateArrows);
    updateArrows();
  });

  document.querySelectorAll('[data-qt-review-photo]').forEach(function(img){
    if(img.dataset.qtLightboxWired) return;
    img.dataset.qtLightboxWired = 'true';
    img.addEventListener('click', function(){
      var full = img.getAttribute('data-full') || img.src;

      var overlay = document.createElement('div');
      overlay.style.position = 'fixed';
      overlay.style.top = '0';
      overlay.style.left = '0';
      overlay.style.width = '100%';
      overlay.style.height = '100%';
      overlay.style.background = 'rgba(0,0,0,0.85)';
      overlay.style.display = 'flex';
      overlay.style.alignItems = 'center';
      overlay.style.justifyContent = 'center';
      overlay.style.zIndex = '99999';
      overlay.style.cursor = 'zoom-out';
      overlay.style.padding = '24px';
      overlay.style.boxSizing = 'border-box';

      var big = document.createElement('img');
      big.src = full;
      big.style.maxWidth = '90vw';
      big.style.maxHeight = '90vh';
      big.style.objectFit = 'contain';
      big.style.borderRadius = '4px';
      overlay.appendChild(big);

      var closeBtn = document.createElement('button');
      closeBtn.type = 'button';
      closeBtn.innerHTML = '&times;';
      closeBtn.setAttribute('aria-label', 'Close');
      closeBtn.style.position = 'fixed';
      closeBtn.style.top = '16px';
      closeBtn.style.right = '20px';
      closeBtn.style.background = 'transparent';
      closeBtn.style.border = 'none';
      closeBtn.style.color = '#fff';
      closeBtn.style.fontSize = '32px';
      closeBtn.style.lineHeight = '1';
      closeBtn.style.cursor = 'pointer';
      overlay.appendChild(closeBtn);

      function closeOverlay(){
        document.body.style.overflow = '';
        document.removeEventListener('keydown', onKey);
        overlay.remove();
      }
      function onKey(e){ if(e.key === 'Escape') closeOverlay(); }

      overlay.addEventListener('click', function(e){ if(e.target === overlay) closeOverlay(); });
      closeBtn.addEventListener('click', closeOverlay);
      document.addEventListener('keydown', onKey);

      document.body.style.overflow = 'hidden';
      document.body.appendChild(overlay);
    });
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ai_gen_block_64e6ea1"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-qt-artistfilter]').forEach(function(row){
  if (row.dataset.qtWired) return;
  row.dataset.qtWired = 'true';
  var param = row.dataset.param;

  row.querySelectorAll('a[data-value]').forEach(function(pill){
    pill.addEventListener('click', function(e){
      // Active pill: let Shopify's own url_to_remove handle deselection.
      if (pill.dataset.active === 'true') return;

      e.preventDefault();
      // dataset decodes HTML entities, so this is the real value: "Djadja & Dinaz"
      var raw = pill.dataset.value;
      var base = new URL(pill.dataset.clearUrl, window.location.origin);
      // set() replaces any existing value of this filter -> single-select,
      // and encodes correctly for &, ', accents, anything.
      base.searchParams.set(param, raw);
      window.location.href = base.toString();
    });
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ai_gen_block_a1204bb"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[class*="qt-reveal-btn-"]').forEach(function(btn){
  if(btn.dataset.qtWired) return;
  btn.dataset.qtWired = 'true';
  var suffix = [...btn.classList].find(function(c){return c.indexOf('qt-reveal-btn-')===0;}).replace('qt-reveal-btn-','');
  var link = document.querySelector('.qt-reveal-link-' + suffix);
  var local = btn.getAttribute('data-local');
  var domain = btn.getAttribute('data-domain');
  btn.addEventListener('click', function(){
    var address = local + '@' + domain;
    link.href = 'mailto:' + address;
    link.textContent = address;
    link.classList.add('show');
    btn.classList.add('hide');
  });
});
  } catch(e) { console.error(e); }
})();

})();
